// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__24Xor","gfeWrapper":"CalendarEvent_gfeWrapper__1HL-L"};